import { ITToolUsageFieldName } from "@app/pages/kpi-data-mgmt/it-tools-usage/it-tools-usage.constant";
import { SmartSearchHelper } from "@app/shared/components/smart-search-form/smart-search.helper";
import { CommonSearchCriteria } from "@app/shared/models/common-data.model";
import { DrivingBehaviorFieldName } from "@app/pages/kpi-data-mgmt/driving-behavior/driving-behavior.constant";
import { CoachingFieldName } from "@app/pages/coaching/coaching.constant";
import { SafetyFieldName } from "@app/pages/kpi-data-mgmt/safety/safety.constant";
import { AchievementFieldName } from "@app/pages/achievement/achievement.constant";
import { ReportLinkFieldName } from "@app/pages/report-link/report-link.constant";
import { CommonFieldName } from "@app/shared/constants";

export interface ISpecificQueryCriteriaGenerator {
  generate?: (criterion: CommonSearchCriteria) => string;
}

export class SpecificQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {}

export class KpiITToolUsageQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === ITToolUsageFieldName.kpiDate && criterion.searchValue !== "") {
      return SmartSearchHelper.CreateDatePeriodQueryString(criterion);
    }

    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class KpiSafetyQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === SafetyFieldName.emIncidentStartTime && criterion.searchValueStart && criterion.searchValueEnd) {
      return SmartSearchHelper.CreateDateTimeQueryString(criterion);
    }

    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class KpiDrivingBehaviorQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === DrivingBehaviorFieldName.kpiTime && criterion.searchValueStart && criterion.searchValueEnd) {
      return SmartSearchHelper.CreateDateTimeQueryString(criterion);
    }

    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class KpiEconomyQueryCriteriaGenerator extends KpiITToolUsageQueryCriteriaGenerator {}

export class KpiOthersQueryCriteriaGenerator extends KpiDrivingBehaviorQueryCriteriaGenerator {}

export class UserProfileQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === ITToolUsageFieldName.kpiDate && criterion.searchValue !== "") {
      return SmartSearchHelper.CreateDatePeriodQueryString(criterion);
    } else if (criterion.searchBy === CommonFieldName.businessTypes && criterion.searchValue !== "") {
      return SmartSearchHelper.CreateBusinessTypeQueryString(criterion);
    }

    return "";
  }
}

export class CoachingQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === CoachingFieldName.coachingTime && criterion.searchValueStart && criterion.searchValueEnd) {
      return SmartSearchHelper.CreateUTCDateTimeQueryString(criterion);
    }

    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class AchievementQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === AchievementFieldName.achieveDate && criterion.searchValueStart && criterion.searchValueEnd) {
      return SmartSearchHelper.CreateDateQueryString(criterion);
    }

    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class AwardQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === AchievementFieldName.awardDate && criterion.searchValueStart && criterion.searchValueEnd) {
      return SmartSearchHelper.CreateDateQueryString(criterion);
    }

    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class ReportLinkQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === ReportLinkFieldName.reportName && criterion.searchValue !== "") {
      return SmartSearchHelper.CreateFuzzyQueryString(criterion);
    }

    return "";
  }
}

export class KpiConfigurationQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === CommonFieldName.businessType && criterion.searchValue !== "") {
      return SmartSearchHelper.CreateBusinessTypeQueryString(criterion);
    }

    return "";
  }
}

export class DriverDataQueryCriteriaGenerator implements ISpecificQueryCriteriaGenerator {
  generate(criterion: CommonSearchCriteria) {
    if (criterion.searchBy === CommonFieldName.apexId) {
      return SmartSearchHelper.CreateSpecifiedFuzzyQueryString(criterion);
    }

    return "";
  }
}
